import {Route} from 'react-router-dom';
import Timeout from './Timeout';

const TimeoutRoute = () => {
  return <Route key="timeout" path="/timeout" render={() => <Timeout />} />;
};

export default TimeoutRoute;
